module.exports = __webpack_public_path__ + "static/media/15.4893a7b6.jpg";